import { POST_TRANSACTION, POST_TRANSACTION_FAILURE, POST_TRANSACTION_SUCCESS } from '../actions'
import { POST_TRANSACTION_SUCCESS_ACKNOWLEDGE } from '../actions/tradeActions'
import { TradeSubmissionDetails, TransactionState } from '../types'

const INITIAL_STATE: TransactionState = {
  loadingResult: false,
  tradeSubmittedMessage: undefined,
  tradeSubmissionFailedMessage: undefined,
  tradeSubmissionDetails: undefined,
}

export const transactionReducer = (
  state: TransactionState = INITIAL_STATE,
  action: {
    type: string
    tradeSubmittedMessage?: string
    tradeSubmissionFailedMessage?: string
    tradeSubmissionDetails?: TradeSubmissionDetails
  }
) => {
  const { type, tradeSubmittedMessage, tradeSubmissionFailedMessage, tradeSubmissionDetails } = action
  switch (type) {
    case POST_TRANSACTION:
      return { ...state, ...INITIAL_STATE, loadingResult: true }
    case POST_TRANSACTION_FAILURE:
      return { ...state, loadingResult: false, tradeSubmissionFailedMessage }
    case POST_TRANSACTION_SUCCESS:
      return { ...state, loadingResult: false, tradeSubmittedMessage, tradeSubmissionDetails }
    case POST_TRANSACTION_SUCCESS_ACKNOWLEDGE:
      return { ...state, ...INITIAL_STATE }
    default:
      return state
  }
}
